module.exports = __webpack_public_path__ + "static/img/admin_logo.789815d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo/admin_logo.svg
// module id = D1Ch
// module chunks = 1